import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["offset", "time"]
  static values = { fillCurrent: Boolean }

  connect() {
    if (this.fillCurrentValue && !this.timeTarget.value) {
      const now = new Date()
      const localNow = new Date(now.getTime() - now.getTimezoneOffset() * 60_000)
      this.timeTarget.value = localNow.toISOString().slice(0, 16)
    }
    this.update()
  }

  update() {
    const localTime = this.timeTarget.value ? new Date(this.timeTarget.value) : new Date()
    this.offsetTarget.value = Number.isNaN(localTime.getTime())
      ? ""
      : String(localTime.getTimezoneOffset())
  }
}
